import { Alert, SectionCard, Select, type SelectOption } from "@/deps/ui-library";
import { useSaveYearEndMethod, useYearEndMethod } from "@/api/queries";
import type { YearEndMethod } from "@/api/types";
import { useCan } from "@/app/session";

const OPTIONS: SelectOption[] = [
  { value: "calculated", label: "Calculated" },
  { value: "manual", label: "Manual closing journal" },
];

export const METHOD_HELP: Record<YearEndMethod, string> = {
  calculated:
    "Rigo works out the closing journal and posts it automatically when you close the year. You can edit it later with a manual journal.",
  manual:
    "You write the closing journal yourself. When you close the year, Rigo asks which journal to close on and posts nothing of its own.",
};

/** The company's choice of how a year closes (ADR-0056). A company that hasn't chosen is on Calculated. */
export function YearEndMethodCard() {
  const { data: method } = useYearEndMethod();
  const save = useSaveYearEndMethod();
  const can = useCan();

  return (
    <SectionCard title="Year-end closing method">
      <div className="flex flex-col gap-3">
        {save.isError ? (
          <Alert
            config={{ variant: "subtle", colorScheme: "danger" }}
            description={(save.error as Error).message}
          />
        ) : null}
        <Select
          label="Closing method"
          options={OPTIONS}
          value={method ?? "calculated"}
          disabled={!can("accounting.periods.manage") || save.isPending}
          onChange={(details: { value: SelectOption | SelectOption[] | null }) => {
            const option = Array.isArray(details.value) ? details.value[0] : details.value;
            if (option && option.value !== method) save.mutate(option.value as YearEndMethod);
          }}
          showClearButton={false}
        />
        <p className="text-fg-muted text-sm">{METHOD_HELP[method ?? "calculated"]}</p>
      </div>
    </SectionCard>
  );
}
